export const initialAbility = [
  {
    subject: 'Anonymous',
    action: 'view',
  },
]

export const _ = undefined
